
import Button from './Button'
import { ReactNode } from 'react';
type ToastMessage = {
    success?: string,
    cancel?: string,
    error?: string
}
const SecondaryButton = (props: {
    loading?: boolean;
    isDisabled?: any;
    onClick?: any;
    value: any;
    classes?: string;
    isDisabledWithoutAnimation?: any;
    icon?: any;
    confirmationMessage?: string;
    hideToastMessages?: boolean
    toastMessages?: ToastMessage,
    svg?: ReactNode
}) => {
    const { classes } = props;

    return (
        <Button {...{ ...props, classes: classes + " py-2 px-4 border-[#E3E8EF] gap-[10px] flex justify-center items-center text-[15px] rounded border-1 font-medium text-[#8A92A6]  disabled:bg-[#dddddd] cursor-pointer disabled:cursor-not-allowed hover:drop-shadow-md " }} ></Button>
    );
};

export default SecondaryButton;



